import React, { useCallback, useMemo } from 'react';
import { ParticlesProvider, Particles } from '@tsparticles/react';
import { loadSlim } from '@tsparticles/slim';

function ParticlesBackground() {
  // Callback estable para inicializar el motor de partículas (slim bundle).
  const init = useCallback(async (engine) => {
    await loadSlim(engine);
  }, []);

  // Configuración equivalente a la del angular-particle original.
  const options = useMemo(
    () => ({
      fullScreen: {
        enable: true,
        zIndex: -1
      },
      particles: {
        number: {
          value: 120,
          density: {
            enable: true,
            area: 800
          }
        },
        color: {
          value: '#ffffff'
        },
        shape: {
          type: 'circle'
        },
        opacity: {
          value: { min: 0, max: 1 },
          animation: {
            enable: true,
            speed: 1,
            sync: false
          }
        },
        size: {
          value: { min: 0.3, max: 3 }
        },
        links: {
          enable: false
        },
        move: {
          enable: true,
          speed: 1,
          direction: 'none',
          random: true,
          straight: false,
          outModes: {
            default: 'out'
          }
        }
      },
      interactivity: {
        detectsOn: 'canvas',
        events: {
          onHover: {
            enable: true,
            mode: 'bubble'
          },
          onClick: {
            enable: false
          },
          resize: true
        },
        modes: {
          bubble: {
            distance: 250,
            size: 0,
            duration: 2,
            opacity: 0,
            speed: 3
          }
        }
      },
      detectRetina: true
    }),
    []
  );

  return (
    <ParticlesProvider init={init}>
      <Particles id="tsparticles" options={options} />
    </ParticlesProvider>
  );
}

export default ParticlesBackground;
